import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_REPORT_TEMPLATE_LIST } from "../services/get-report-template-list";

export const TOGGLE_REPORT_TEMPLATE_LIST_ACTION_POPOVER =
  "TOGGLE_REPORT_TEMPLATE_LIST_ACTION_POPOVER";
export const SET_REPORT_CONFIG_SELECTED_INDEX =
  "SET_REPORT_CONFIG_SELECTED_INDEX";

const initialState = {
  reportTemplateList: [],
  auditGroupList: [],
  auditGroupIds: [],
  selectedReportConfigTabIndex: 0,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_REPORT_TEMPLATE_LIST_ACTION_POPOVER:
    case SET_REPORT_CONFIG_SELECTED_INDEX:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_REPORT_TEMPLATE_LIST)(action)) {
        return { ...state, reportTemplateList: [] };
      }
      if (isAsyncComplete(GET_REPORT_TEMPLATE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          reportTemplateList: response.reportTemplateList,
          auditGroupList: response.auditGroupList,
        };
      }
      return state;
    default:
      return state;
  }
}
